import { render } from "./FilterPreloader.vue?vue&type=template&id=be0b792e"
import script from "./FilterPreloader.vue?vue&type=script&lang=js"
export * from "./FilterPreloader.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__